
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails || !this.elements.viewer) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector('button');

            if (!button) return;

            button.addEventListener(
              'click',
              this.setActiveMedia.bind(
                this,
                mediaToSwitch.dataset.target,
                false
              )
            );
          });

        if (
          this.dataset.desktopLayout !== 'stacked' &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;

        const mediaId = event.detail?.currentElement?.dataset?.mediaId;

        if (!mediaId) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${CSS.escape(String(mediaId))}"]`
        );

        if (thumbnail) {
          this.setActiveThumbnail(thumbnail);
        }
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer || mediaId == null) return;

        const safeMediaId = CSS.escape(String(mediaId));

        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${safeMediaId}"]`
        );

        // Prevent the null.classList error when a media slide is missing.
        if (!activeMedia) {
          console.warn(
            `MediaGallery: No gallery slide found for media ID "${mediaId}".`
          );
          return;
        }

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${safeMediaId}"]`
            );

            if (activeThumbnail?.parentElement) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (
            this.elements.thumbnails &&
            activeMedia.parentElement
          ) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft
            });
          }

          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === 'stacked'
          ) {
            // Keep the existing Dawn scroll behavior unchanged.
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${safeMediaId}"]`
        );

        // A gallery slide may exist without a corresponding thumbnail.
        if (!activeThumbnail) return;

        this.setActiveThumbnail(activeThumbnail);

        const position = activeThumbnail.dataset.mediaPosition;

        if (position) {
          this.announceLiveRegion(activeMedia, position);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => {
            element.removeAttribute('aria-current');
          });

        const button = thumbnail.querySelector('button');

        if (button) {
          button.setAttribute('aria-current', 'true');
        }

        if (
          typeof this.elements.thumbnails.isSlideVisible === 'function' &&
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) {
          return;
        }

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft
          });
        }
      }

      announceLiveRegion(activeItem, position) {
        if (!activeItem || !this.elements.liveRegion) return;

        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          if (!this.elements.liveRegion) return;

          this.elements.liveRegion.setAttribute('aria-hidden', 'false');

          if (window.accessibilityStrings?.imageAvailable) {
            this.elements.liveRegion.innerHTML =
              window.accessibilityStrings.imageAvailable.replace(
                '[index]',
                position
              );
          }

          window.setTimeout(() => {
            if (this.elements.liveRegion) {
              this.elements.liveRegion.setAttribute('aria-hidden', 'true');
            }
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        if (!activeItem) return;

        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferredMedia = activeItem.querySelector('.deferred-media');

        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer?.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');

        if (!this.elements.viewer.sliderItems) return;

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}
